module.exports = __webpack_public_path__ + "static/img/sdl_image@2x.8bfd447.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/2x/sdl_image@2x.png
// module id = vVcJ
// module chunks = 1